import UNIQUE from '@/common/unique'
import columnDetail from '../columnDetail'
import store from '@/stores/'
const langValue = function () {
  return Object.assign({}, store.state.setting.lang.langValue)
}

export default {
  id: 'text',
  name: 'text',
  type: 'standard',
  moduleName: 'editor_module_text',
  hide: true,
  dataSet: {
    mods: 'text',
    column: [
      {
        columnId: UNIQUE.mid(),
        type: 'text',
        value: langValue(),
        detail: {
          options: ['link', 'border', 'background', 'text', 'upload', 'radius'],
          link: columnDetail.link,
          border: columnDetail.border,
          background: columnDetail.background,
          color: columnDetail.text,
          upload: columnDetail.upload,
          radius: columnDetail.radius
        }
      }
    ]
  },
  setting: {
    layout: {
      options: [
        'link',
        'fullsize',
        'background',
        'border',
        'text',
        'padding'
      ]
    },
    action: null,
    detail: {}
  }
}
